import CheckboxList from './checkboxList'

export default CheckboxList
